import {
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Tooltip
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import messages from "../../../assets/locale/messages";
import EmptyState from "../../../components/EmptyState";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/Table";
import { getDirectorsRequest } from "../../../store/Directors/actions";
import { setSelectedDirectors } from "../../../store/Programs/actions";

const DirectorsList = ({
  lang,
  setDeleteModal,
  showActions = true,
  showRadioButtons = false,
  selectedProgram
}) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.directors.list);
  const meta = useSelector((state) => state.directors.meta);
  const isLoading = useSelector((state) => state.loader);
  const [page, setPage] = useState(1);
  const perPage = 10;

  const [arrOfIds, setArrOfIds] = useState([]);

  // Fetch directors on mount
  useEffect(() => {
    dispatch(getDirectorsRequest({ page: 1, items: perPage }));
  }, [dispatch]);

  // Sync selected IDs when selectedProgram updates
  useEffect(() => {
    if (selectedProgram?.program_directors?.length) {
      const ids = selectedProgram.program_directors.map((d) => d.id);
      setArrOfIds(ids);
      dispatch(setSelectedDirectors(ids));
    }
  }, [selectedProgram, dispatch]);

  const handlePagination = (event, page) => {
    setPage(page);
    dispatch(getDirectorsRequest({ page, items: perPage }));
  };

  const handleChange = (event) => {
    const { value, checked } = event.target;
    console.log("checked in handle", checked);
    console.log("value in handle", value);

    const numericId = Number(value);

    setArrOfIds((prev) => {
      const updatedArrIds = checked
        ? [...prev, numericId]
        : prev.filter((id) => id !== numericId);

      dispatch(setSelectedDirectors(updatedArrIds));
      return updatedArrIds;
    });
  };

  const {
    cols: { secondName, firstName, email },
    shared: { deleteLabel }
  } = messages[lang];

  const isChecked = (id) => arrOfIds.includes(id);

  const tableRows = useMemo(() => {
    return list.map((row) => (
      <TableRow className="table__row" key={row.id}>
        {!!showRadioButtons && (
          <TableCell className="table__cell" align="left">
            <Checkbox
              checked={isChecked(row.id)}
              onChange={handleChange}
              value={row.id}
              inputProps={{ "aria-label": "Select Director" }}
            />
          </TableCell>
        )}
        <TableCell className="table__cell" align="left">
          {row.first_name}
        </TableCell>
        <TableCell className="table__cell" align="left">
          {row.second_name}
        </TableCell>
        <TableCell className="table__cell" align="left">
          {row.email}
        </TableCell>
        {!!showActions && (
          <TableCell className="table__cell" align="right">
            <Tooltip title={deleteLabel}>
              <span>
                <IconButton
                  onClick={() =>
                    setDeleteModal({ id: row.id, open: true })
                  }
                >
                  <DeleteIcon
                    className="table__delete"
                    fontSize="medium"
                  />
                </IconButton>
              </span>
            </Tooltip>
          </TableCell>
        )}
      </TableRow>
    ));
  }, [list, arrOfIds, showRadioButtons, showActions]);

  return (
    <>
      <Table
        headlines={[
          ...(showRadioButtons ? [null] : []),
          firstName,
          secondName,
          email
        ]}
        hasActions={showActions}
        rows={tableRows}
      />

      {!isLoading && !list.length && <EmptyState />}
      {meta.pages > 1 && (
        <Pagination
          count={meta.pages}
          page={meta.currentPage || page}
          handleChange={handlePagination}
        />
      )}
    </>
  );
};

DirectorsList.propTypes = {
  lang: PropTypes.string,
  selectedProgram: PropTypes.object,
  setDeleteModal: PropTypes.func,
  showActions: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  showRadioButtons: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.any
  ])
};

export default DirectorsList;
